export default "__VITE_ASSET__M2u28pW5__"